import { render } from "./EmployeeTab.vue?vue&type=template&id=2f41d4b5"
import script from "./EmployeeTab.vue?vue&type=script&lang=js"
export * from "./EmployeeTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__